var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusCirlce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/minus-cirlce"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minus-cirlce"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 1.66663C5.40835 1.66663 1.66669 5.40829 1.66669 9.99996C1.66669 14.5916 5.40835 18.3333 10 18.3333C14.5917 18.3333 18.3334 14.5916 18.3334 9.99996C18.3334 5.40829 14.5917 1.66663 10 1.66663ZM13.2667 10.625H6.60002C6.25835 10.625 5.97502 10.3416 5.97502 9.99996C5.97502 9.65829 6.25835 9.37496 6.60002 9.37496H13.2667C13.6084 9.37496 13.8917 9.65829 13.8917 9.99996C13.8917 10.3416 13.6167 10.625 13.2667 10.625Z",
    fill: "#A2A2A2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCirlce);
export default __webpack_public_path__ + "static/media/minus-cirlce.0794aa689a1ad9e8dc03b9be4ba9946e.svg";
export { ForwardRef as ReactComponent };